Vue.component("index-view", {
	template: `
	<div class="search-index">
		<h2 class="subhead">地域で探す</h2>
		<template v-if="store.error">
			<p class="form-action search-result-count empty">{{ store.error }}</p>
		</template>
		<template v-else>
			<ul class="search-by-area-list">
				<li v-if="false">
					<button type="button" class="btn btn-s" @click="searchByArea('現在地')">現在地から</button>
				</li>
				<li>
					<button type="button" class="btn btn-s" @click="searchByArea('能登地域')">能登地域</button>
				</li>
				<li>
					<button type="button" class="btn btn-s" @click="searchByArea('金沢市内')">金沢市内</button>
				</li>
				<li>
					<button type="button" class="btn btn-s" @click="searchByArea('加賀地域')">加賀地域</button>
				</li>
			</ul>
		</template>

		<h2 class="subhead">条件で探す</h2>
		<section class="search-cond">
			<cond-view v-model="localCond" @input="updateResultCount"></cond-view>
			<div class="form-action">
				<template v-if="store.error">
					<p class="search-result-count empty">{{ store.error }}</p>
				</template>
				<template v-else-if="store.showResult && store.resultCount > 0">
					<p class="search-result-count"><big>{{ store.resultCount }}</big>&nbsp;件見つかりました</p>
				</template>
				<template v-else-if="store.showResult && store.resultCount === 0">
					<p class="search-result-count empty">ご指定の条件では見つかりませんでした</p>
				</template>
				<template v-else>
					<p class="search-result-count empty">検索条件を指定してください</p>
				</template>
				<button type="button" class="btn btn-p" @click="showResultsMap"
				 :disabled="store.error || !store.showResult || store.resultCount === 0"
				>地図で表示</button>
				<button type="button" class="btn btn-s" @click="showResultsList"
				 :disabled="store.error || !store.showResult || store.resultCount === 0"
				>一覧表示</button>
			</div>
		</section>
	</div>
	`,

	props: {
		cond: Object
	},

	data() {
		return {
			store,
			localCond: this.cond
		};
	},

	methods: {
		searchByArea(area) {
			this.$emit("searchByArea", area);
		},
		updateResultCount() {
			this.$emit("updateResultCount", this.localCond);
		},
		showResultsMap() {
			this.$emit("showResultsMap", this.localCond);
		},
		showResultsList() {
			this.$emit("showResultsList", this.localCond);
		},
	},

	watch: {
		cond () {
			this.$set(this, 'localCond', this.cond)
			this.updateResultCount()
		}
	}
});
